export async function loadGridCsv(params: {gridName: string}): Promise<Blob> {
    // return apiClient
    //     .get<BlobPart>('/csv', {
    //         params,
    //         responseType: 'blob',
    //         transformResponse: (data): Response => {
    //             if (data.type === 'application/json') {
    //                 data.message = 'Error';
    //             }
    //             return data;
    //         },
    //     })
    //     .then((data) => new Blob([data.data], {type: 'text/csv;charset=utf-8'}));
    return new Promise((res) => {
        setTimeout(() => {
            res(new Blob(['Test csv'], {type: 'text/csv;charset=utf-8'}));
        }, 500);
    });
}
